import type { IconData } from '@stacksjs/iconify-core'

export const spreadsheet: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 64v392h480V64Zm448 360H48V96h416Z\"/><path fill=\"currentColor\" d=\"M88 136h88v32H88zm0 72h88v32H88zm0 72h88v32H88zm0 72h88v32H88zm200-216h136v32H288zm0 72h136v32H288zm0 72h136v32H288zm0 72h136v32H288zm-72-216h32v32h-32zm0 72h32v32h-32zm0 72h32v32h-32zm0 72h32v32h-32z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default spreadsheet
